module.exports = __webpack_public_path__ + "static/img/sp_kv_deco_01.ffff784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/sp_kv_deco_01.png
// module id = 735D
// module chunks = 0